import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProgressLoaderService } from '../../service/progress-loader.service';
import { PortfolioService } from '../../service/portfolio.service';
import { showErrorToast, showSuccessToast } from '../../utilities/toast-utils';
import { MessageService } from 'primeng/api';
import { PolicySummaryComponent } from './policy-summary.component';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { LanguageService } from '../../service/language.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CustomToastrService } from '../../service/custom-toastr.service';
import { PolicySummary } from '../../models/common-data-types';

@Component({
    selector: 'app-view-portfolio',
    standalone: true,
    imports: [
        PolicySummaryComponent,
        CommonModule,
        ButtonModule,
        CardModule,
        TranslateModule,
        DividerModule,
    ],
    templateUrl: './view-portfolio.component.html',
    styleUrl: './view-portfolio.component.scss',
})
export class ViewPortfolioComponent implements OnInit {
    loading: boolean = false;
    policies: PolicySummary[] = [];
    selectedLanguage: any = null;

    constructor(
        private router: Router,
        private progressService: ProgressLoaderService,
        private portfolioService: PortfolioService,
        private languageService: LanguageService,
        private translate: TranslateService,
        private messageService: MessageService,
        private wiseToastr: CustomToastrService
    ) {}

    ngOnInit(): void {
        this.getCustomerPoftfolio();
        this.initializeLocale();
    }

    getCustomerPoftfolio() {
        this.loading = true;
        this.progressService.show('Loading portfolio');
        this.portfolioService.getPortfolio().subscribe({
            next: (data) => {
                this.loading = false;
                this.progressService.hide();
                this.policies = data;
                this.showSuccess(
                    'Portfolio loaded successfully'
                );
            },
            error: (err) => {
                this.progressService.hide();
                this.showError(this.translate.instant(err.error.messageKey))
            },
            complete: () => {},
        });
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    showSuccess(message: string){
      this.wiseToastr.showSuccess(message);
    }

    showError(message: string){
      this.wiseToastr.showError(message);
    }

    setLanguage(language: string) {
        this.translate.use(language);
        this.languageService.setLanguage(language);
    }

    viewDetails(policyId: string) {
        this.router.navigate(['/home/portfolio', policyId]);
    }

    hasPolicies(): boolean {
        return this.policies.length > 0;
    }
}
